export default __webpack_public_path__ + "static/remeltedwax-1684a00a093a95fcde4d0df80c64c687.png";